import common from './common';
import SplashScene from './scenes/SplashScene';
import GameScene from './scenes/GameScene';
import SavedData from './SavedData';
import TypeSelectionScene from './scenes/TypeSelectionScene';
import ImageSelectionScene from './scenes/ImageSelectionScene';

export default class Application {
	constructor() {
	}

	init() {
		common.savedData = new SavedData();
		common.savedData.init();

		this.showSplashScene();
		//this.showTypeSelectScene();

		P3.audio.playMusic('music_winter_magic_loop_00');
	}

	showSplashScene() {
		const scene = new SplashScene();
		scene.autoAppear = false;

		scene.signals.next.add(()=> {
			this.showTypeSelectScene();
		}, this);

		this.fadeTransition(function() {
			P3.scene.show(scene);
		}, function() {
			scene.appear();
		}, this);
		return scene;
	}

	showTypeSelectScene() {
		const scene = new TypeSelectionScene();
		scene.autoAppear = false;

		scene.signals.next.add(()=> {
			this.showImageSelectionScene();
		}, this);
		scene.signals.previous.add(()=> {
			this.showSplashScene();
		}, this);

		this.fadeTransition(function() {
			P3.scene.show(scene);
		}, function() {
			scene.appear();
		}, this);
		return scene;
	}

	showImageSelectionScene() {
		const scene = new ImageSelectionScene();
		scene.autoAppear = false;

		scene.signals.next.add(()=> {
			this.showGameScene();
		}, this);
		scene.signals.previous.add(()=> {
			this.showTypeSelectScene();
		}, this);
		scene.signals.home.add(()=> {
			this.showSplashScene();
		}, this);

		this.fadeTransition(function() {
			P3.scene.show(scene);
		}, function() {
			scene.appear();
		}, this);
		return scene;
	}

	showGameScene() {
		const scene = new GameScene();
		scene.autoAppear = false;

		scene.signals.next.add(()=> {
			this.showGameScene();
		}, this);
		scene.signals.previous.add(()=> {
			this.showImageSelectionScene();
		}, this);
		scene.signals.home.add(()=> {
			this.showSplashScene();
		}, this);

		this.fadeTransition(function() {
			P3.scene.show(scene);
		}, function() {
			scene.appear();
		}, this);
		return scene;
	}

	fadeTransition(a, b, scope) {
		scope = scope || window;

		const transition = new P3.FadeTransition(0x0);
		common.transitions.addChild(transition);

		transition.signals.in.add(function() {
			transition.out();
			a && a.call(scope);
		}, this);
		transition.signals.out.add(function() {
			transition.destroy();
			b && b.call(scope);
		}, this);
		transition.in();
	}
}
